export default __webpack_public_path__ + "css/returnDetails.bundle.css";